(function reefChargeLightning() {
  if (window.NewDawnReefChargeLightning) {
    window.NewDawnReefChargeLightning.hydrateNodes(document);
    return;
  }

  const LIGHTNING_SHAPES = [
    {
      main: 'M78 0 L64 58 L88 116 L48 182 L70 244 L54 316 L74 420',
      branches: ['M66 98 L110 150 L92 198', 'M54 188 L20 244 L36 304'],
    },
    {
      main: 'M58 0 L72 54 L54 118 L84 178 L62 236 L78 296 L60 420',
      branches: ['M58 126 L24 184 L38 232', 'M76 182 L112 234 L96 286'],
    },
    {
      main: 'M82 0 L70 68 L94 128 L60 190 L82 250 L66 326 L84 420',
      branches: ['M88 132 L120 176 L106 228', 'M66 206 L34 256 L48 314'],
    },
    {
      main: 'M62 0 L50 62 L74 122 L42 196 L64 256 L50 332 L70 420',
      branches: ['M72 118 L104 166 L92 222', 'M46 212 L18 268 L30 324'],
    },
  ];

  const CONTEXT_CONFIGS = {
    shell: {
      delayRange: [4000, 8000],
      introDelayRange: [1200, 2400],
      leftRange: [42, 78],
      topRange: [-3, 5],
      widthRange: [11.5, 17],
      heightRange: [60, 84],
      angleRange: [-7, 7],
      scaleRange: [0.92, 1.08],
      opacityRange: [0.72, 0.92],
      durationRange: [640, 820],
      branchDelayRange: [80, 160],
      doubleStrikeChance: 0.18,
    },
    portal: {
      delayRange: [4200, 8200],
      introDelayRange: [900, 1800],
      leftRange: [48, 84],
      topRange: [-2, 6],
      widthRange: [8, 12.5],
      heightRange: [54, 78],
      angleRange: [-8, 8],
      scaleRange: [0.84, 1],
      opacityRange: [0.64, 0.84],
      durationRange: [620, 780],
      branchDelayRange: [80, 150],
      doubleStrikeChance: 0.14,
    },
  };

  const instances = new Map();
  const reduceMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  function randomBetween(min, max) {
    return min + Math.random() * (max - min);
  }

  function randomInt(min, max) {
    return Math.round(randomBetween(min, max));
  }

  function pickRandom(items) {
    return items[Math.floor(Math.random() * items.length)];
  }

  function formatPercent(value) {
    return `${value.toFixed(2)}%`;
  }

  function formatRem(value) {
    return `${value.toFixed(2)}rem`;
  }

  function formatDeg(value) {
    return `${value.toFixed(2)}deg`;
  }

  function formatNumber(value) {
    return value.toFixed(3);
  }

  function getContextConfig(node) {
    const context = node.dataset.reefChargeLightningContext || 'shell';
    return CONTEXT_CONFIGS[context] || CONTEXT_CONFIGS.shell;
  }

  function renderBolt(shape, index) {
    const branches = shape.branches
      .map(
        (path, branchIndex) => `
          <path class="reef-charge-lightning__bolt-path reef-charge-lightning__bolt-path--glow reef-charge-lightning__bolt-path--branch reef-charge-lightning__bolt-path--branch-${branchIndex + 1}" pathLength="100" d="${path}"></path>
          <path class="reef-charge-lightning__bolt-path reef-charge-lightning__bolt-path--core reef-charge-lightning__bolt-path--branch reef-charge-lightning__bolt-path--branch-${branchIndex + 1}" pathLength="100" d="${path}"></path>
        `,
      )
      .join('');

    return `
      <div class="reef-charge-lightning__bolt reef-charge-lightning__bolt--${index + 1}" data-reef-charge-bolt>
        <svg class="reef-charge-lightning__bolt-svg" viewBox="0 0 140 420" preserveAspectRatio="xMidYMin meet" aria-hidden="true" focusable="false">
          <path class="reef-charge-lightning__bolt-path reef-charge-lightning__bolt-path--glow" pathLength="100" d="${shape.main}"></path>
          <path class="reef-charge-lightning__bolt-path reef-charge-lightning__bolt-path--core" pathLength="100" d="${shape.main}"></path>
          ${branches}
        </svg>
      </div>
    `;
  }

  function renderLightningScene() {
    return `
      <div class="reef-charge-lightning__storm-bank"></div>
      <div class="reef-charge-lightning__sky-glow"></div>
      <div class="reef-charge-lightning__bolt-field">
        ${LIGHTNING_SHAPES.map((shape, index) => renderBolt(shape, index)).join('')}
      </div>
    `;
  }

  function clearActiveTimers(instance) {
    instance.activeTimers.forEach((timerId) => window.clearTimeout(timerId));
    instance.activeTimers = [];
  }

  function cleanupInstance(instance) {
    if (instance.timerId) {
      window.clearTimeout(instance.timerId);
      instance.timerId = null;
    }

    clearActiveTimers(instance);
    instance.node.classList.remove('is-striking');
    instance.bolts.forEach((bolt) => bolt.classList.remove('is-active'));
  }

  function scheduleNextStrike(instance, isIntro) {
    if (!instance.node.isConnected || reduceMotionQuery.matches) {
      cleanupInstance(instance);
      return;
    }

    const config = getContextConfig(instance.node);
    const range = isIntro ? config.introDelayRange : config.delayRange;

    instance.timerId = window.setTimeout(() => {
      instance.timerId = null;
      triggerStrike(instance);
    }, randomInt(range[0], range[1]));
  }

  function configureBolt(bolt, config) {
    const left = randomBetween(config.leftRange[0], config.leftRange[1]);
    const top = randomBetween(config.topRange[0], config.topRange[1]);
    const width = randomBetween(config.widthRange[0], config.widthRange[1]);
    const height = randomBetween(config.heightRange[0], config.heightRange[1]);
    const angle = randomBetween(config.angleRange[0], config.angleRange[1]);
    const scale = randomBetween(config.scaleRange[0], config.scaleRange[1]);
    const opacity = randomBetween(config.opacityRange[0], config.opacityRange[1]);
    const duration = randomInt(config.durationRange[0], config.durationRange[1]);
    const branchDelay = randomInt(
      config.branchDelayRange[0],
      config.branchDelayRange[1],
    );

    bolt.style.setProperty('--reef-charge-bolt-left', formatPercent(left));
    bolt.style.setProperty('--reef-charge-bolt-top', formatPercent(top));
    bolt.style.setProperty('--reef-charge-bolt-width', formatRem(width));
    bolt.style.setProperty('--reef-charge-bolt-height', formatPercent(height));
    bolt.style.setProperty('--reef-charge-bolt-angle', formatDeg(angle));
    bolt.style.setProperty('--reef-charge-bolt-scale', formatNumber(scale));
    bolt.style.setProperty('--reef-charge-bolt-opacity', formatNumber(opacity));
    bolt.style.setProperty('--reef-charge-bolt-duration', `${duration}ms`);
    bolt.style.setProperty('--reef-charge-bolt-branch-delay', `${branchDelay}ms`);
  }

  function activateBolt(instance, bolt) {
    const config = getContextConfig(instance.node);
    configureBolt(bolt, config);

    bolt.classList.remove('is-active');
    void bolt.offsetWidth;
    bolt.classList.add('is-active');

    const duration = parseInt(
      bolt.style.getPropertyValue('--reef-charge-bolt-duration'),
      10,
    );
    const deactivateTimerId = window.setTimeout(() => {
      bolt.classList.remove('is-active');
      instance.activeTimers = instance.activeTimers.filter(
        (timerId) => timerId !== deactivateTimerId,
      );
    }, duration + 440);

    instance.activeTimers.push(deactivateTimerId);
  }

  function triggerStrike(instance) {
    if (!instance.node.isConnected) {
      cleanupInstance(instance);
      instances.delete(instance.node);
      return;
    }

    const config = getContextConfig(instance.node);
    const availableBolts = instance.bolts.slice();
    const primaryBolt = pickRandom(availableBolts);

    instance.node.classList.add('is-striking');
    activateBolt(instance, primaryBolt);

    if (Math.random() < config.doubleStrikeChance) {
      const secondaryOptions = availableBolts.filter((bolt) => bolt !== primaryBolt);

      if (secondaryOptions.length > 0) {
        const secondaryBolt = pickRandom(secondaryOptions);
        const secondaryTimerId = window.setTimeout(() => {
          activateBolt(instance, secondaryBolt);
          instance.activeTimers = instance.activeTimers.filter(
            (timerId) => timerId !== secondaryTimerId,
          );
        }, randomInt(90, 170));

        instance.activeTimers.push(secondaryTimerId);
      }
    }

    const calmTimerId = window.setTimeout(() => {
      instance.node.classList.remove('is-striking');
      instance.activeTimers = instance.activeTimers.filter(
        (timerId) => timerId !== calmTimerId,
      );
    }, 960);

    instance.activeTimers.push(calmTimerId);
    scheduleNextStrike(instance, false);
  }

  function hydrateNode(node) {
    const existingInstance = instances.get(node);

    if (existingInstance) {
      cleanupInstance(existingInstance);
    }

    node.innerHTML = renderLightningScene();

    const instance = {
      node,
      bolts: Array.from(node.querySelectorAll('[data-reef-charge-bolt]')),
      timerId: null,
      activeTimers: [],
    };

    instances.set(node, instance);
    node.dataset.reefChargeLightningReady = 'true';

    if (!reduceMotionQuery.matches) {
      scheduleNextStrike(instance, true);
    }
  }

  function collectNodes(root) {
    const nodes = [];

    if (root && root.nodeType === 1 && root.matches('[data-reef-charge-lightning]')) {
      nodes.push(root);
    }

    const scopedRoot = root && root.querySelectorAll ? root : document;
    scopedRoot.querySelectorAll('[data-reef-charge-lightning]').forEach((node) => {
      nodes.push(node);
    });

    return nodes;
  }

  function hydrateNodes(root) {
    collectNodes(root).forEach((node) => {
      if (node.isConnected) {
        hydrateNode(node);
      }
    });
  }

  function destroyNodes(root) {
    collectNodes(root).forEach((node) => {
      const instance = instances.get(node);

      if (instance) {
        cleanupInstance(instance);
        instances.delete(node);
      }
    });
  }

  function handleMotionChange() {
    instances.forEach((instance) => {
      cleanupInstance(instance);

      if (!reduceMotionQuery.matches && instance.node.isConnected) {
        scheduleNextStrike(instance, true);
      }
    });
  }

  if (reduceMotionQuery.addEventListener) {
    reduceMotionQuery.addEventListener('change', handleMotionChange);
  } else if (reduceMotionQuery.addListener) {
    reduceMotionQuery.addListener(handleMotionChange);
  }

  document.addEventListener('shopify:section:load', (event) => {
    hydrateNodes(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    destroyNodes(event.target);
  });

  window.NewDawnReefChargeLightning = {
    hydrateNodes,
    destroyNodes,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => hydrateNodes(document), {
      once: true,
    });
  } else {
    hydrateNodes(document);
  }
})();
